import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 10"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "m10.3387.4654 1.3646 1.4622-.2203.2056-.1023.0955-.05.0465-.0982.0917-6.542 6.105-.7062.659L.082 5.2286l1.4142-1.4142L4.032 6.3505l.1276-.1188L9.52 1.2294l.1023-.0955.3438-.3209.1006-.0938.272-.2538Z"
    }, null, -1)
  ])))
}
export default { render: render }